module.exports = __webpack_public_path__ + "static/img/assinatura.b1701fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assinatura.png
// module id = zi2r
// module chunks = 12